import React, {useEffect, useState} from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { useParams, NavLink } from "react-router-dom";
import {tokenExpiredLoginAgain, hostUrl, siteUrl, highTrafficInnerPages } from '../constants/global';
import { callPageRenderTracking } from './common/Helper';
import allActions from '../actions/index';
import Player from '@vimeo/player';


function Sessions(){

    /******get data from localstorage*******/
    let authlogin = localStorage.getItem('authlogin');
    let storageDataAuthLogin = authlogin ? JSON.parse(authlogin) : "";
    var hideshowcls = "tabhide";
    if(storageDataAuthLogin.user_email=="vip@ciisummit.com" || storageDataAuthLogin.user_email=="VIP@CIISUMMIT.COM"){
        hideshowcls = "tabshow";
    }


    const [activeTab, setActiveTab] = useState("tab2022");

    const handleTab1 = () => {
        setActiveTab("tab2022");
    };

    const handleTab2 = () => {
        setActiveTab("tab2021");
    };
    const handleTab3 = () => {
        setActiveTab("tab2020");
    };

    const recSessionBucketState = useSelector((state) => state.RecSessionsBucket.bucket);

    useEffect(() => {

       callPageRenderTracking({page_title:'Archive Sessions',page_link:window.location.href});

       var interval = null;

       var iframe = document.querySelector('iframe[id="recordervideoiframe"]');
   
       if(iframe){
           var player;
           player = "";
           player = new Player(iframe);
           var start_duration;
           var current_time;
           var video_id;
           var video_title;
                
             clearInterval(interval); // stop previous the interval
   
             player.on('play', function() {
                 console.log('played the rec video!!!!');
     
                 clearInterval(interval); // stop previous the interval
                 //get start time
                 player.getCurrentTime().then(function(seconds) {
                     start_duration = seconds;
                     player.getVideoId().then(function(id) {
                     video_id = id;
                         player.getVideoTitle().then(function(title){
                         video_title = title;
                           
                         /********While user play video********/
                         var todayDateTime = new Date().toLocaleString("en-US", {timeZone: "Asia/Kolkata"});
                         var timestamp_server = Math.floor(new Date(todayDateTime).getTime() / 1000);
                         //Convert In India time
                         var timestamp_now = timestamp_server;
   
   
                           /*******Start Video entry in database********/
   
                           /******get data from localstorage*******/
                           let authlogin = localStorage.getItem('authlogin');
                           let storageData = authlogin ? JSON.parse(authlogin) : "";
                          
                           var storageCiisummit = localStorage.getItem('_ciisummit');
                           var myHeaders = new Headers();
                           var formdata = new FormData();
                           formdata.append("username", storageData.user_email);
                           formdata.append("cookie_id", storageCiisummit);
                           formdata.append("user_agent", window.navigator.userAgent);
                           formdata.append("video_title", video_title);
                           formdata.append("video_id", video_id);
                           formdata.append("start_time", start_duration);
                           formdata.append("timestamp_now", timestamp_now);
   
                           
                           var requestOptionsLogin = {
                           method: 'POST',
                           headers: myHeaders,
                           body: formdata,
                           redirect: 'follow'
                           };
   
                           fetch(siteUrl+'/community-rest-functions.php?action=save_recorded_video_tracking_data&event=play',requestOptionsLogin);
                           /********Start Videoentry end********/
   
     
                         //initilize after 30 seconds after click on play button
                         setTimeout(function(){                     
                             /***run on every 1 minutes****/
   
                             interval = setInterval(() => {
                               setUserWatchedRecordedVideoData(formdata)
                             }, 25000);
   
                         }, 2000);
                         
     
                         });
                     });
                 });
                 
             });
   
             /*********Recording video get users watchikng data in some interval**********/
             function setUserWatchedRecordedVideoData(formdata){ 
                 console.log("Interval rec Method", formdata);
                 player.getCurrentTime().then(function(seconds) {
                     current_time = seconds;
   
                       var myHeaders = new Headers();
   
                       /*******Currently Video Watching entry in database********/
                       formdata.set("current_time", current_time);
   
                       var requestOptionsLogin = {
                       method: 'POST',
                       headers: myHeaders,
                       body: formdata,
                       redirect: 'follow'
                       };
   
                       fetch(siteUrl+'/community-rest-functions.php?action=save_recorded_video_tracking_data&event=interval',requestOptionsLogin);
                       /********Start Videoentry end********/   
   
                 });
     
             }        
     
             player.on('pause', function(data) {
                 console.log("paused rec");
                 clearInterval(interval); // stop the interval
             });
     
             player.on('ended', function(data) {
                 console.log("Video rec End");
                 clearInterval(interval); // stop the interval
             });
      
         }

         return () => clearInterval(interval);

    });

    let { id, year } = useParams();

    function Session_data(){
        if(id){

            /*******IF user hit zero then assign 1*******/
             if(id==0){
                id = 1;
            }
            id = id - 1;

            console.log(recSessionBucketState,'asdsadsadsadsa');

            /*********Check index have***********/
            if (typeof(recSessionBucketState[0][year][id]) !== 'undefined'){
                var { vimeolink } = recSessionBucketState[0][year][id];
                //console.log(vimeolink, "vimepo link");
                return (<div className="live-frame recordingsss"><iframe src={vimeolink} id="recordervideoiframe" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen /></div>)
            }else{
                return (
                    <div className="request-box">
                        Sorry no data found !
                    </div>)
            }
        }else{

            return (
                <div className="fullpage-box ">

                     <div className="YearTabs">
                         
                                <ul>
                                    <li className={activeTab === "tab2022" ? "active "+hideshowcls : ""+hideshowcls}>
                                        <button type="button" onClick={handleTab1} rel="tab1" className="tab-nav">2022</button>
                                    </li>

                                    
                                    <li className={activeTab === "tab2021" ? "active "+hideshowcls : ""+hideshowcls }>
                                        <button type="button" id="tab-2" onClick={handleTab2} rel="tab22" className="tab-nav">2021</button>
                                    </li>
                                    
                                    <li className={activeTab === "tab2020" ? "active "+hideshowcls : ""+hideshowcls} >
                                        <button type="button" id="tab-3" onClick={handleTab3} rel="tab22" className="tab-nav">2020</button>
                                    </li>


                                  </ul>


                {
                    recSessionBucketState.map((element,index)=> {
                        //console.log(element, 'eesfsdfsdfds');
                        return <div key={index} className="year-level subtab-content">
                        {
                            Object.entries(element).map((element_inner,index) => {
                                var tab_year = element_inner[0];

                                return (
                                
                                    <div key={index} className={activeTab === "tab"+tab_year ? "tab-content active" : "tab-content"}>
                                            {/* <h2>{element_inner[0]}</h2> */}
                                     <div className="column-box">
   
                                    {
                                        element_inner[1].map((valuedata,index)=> {
                                        const {image, datetext, title, disable} = valuedata;
                                        var toLink = "/sessions/"+tab_year+"/"+(index+1);
                                        var idAdd = "hidecheck"+(disable);

                                        return <div key={index} className="column-section sessions-column-section dsadsadsa" id={idAdd}>
                                                <NavLink exact="true" to={toLink}>
                                                    <div className="column-image"><img src={image} alt="" /></div>
                                                    <div className="archive-col-content">
                                                        <p>{datetext}</p>
                                                        <h3> {title}</h3>
                                                    </div>
                                                </NavLink>
                                            </div>

                                        })

                                    }
                                     </div>
                                </div>)

                            })

                            

                        }
                        </div>

                        })
                }
               
                </div>

                </div>
            )
        }
    }

    
      /******get data from localstorage*******/
 // let authlogin = localStorage.getItem('authlogin');
 // let storageDataAuthLogin = authlogin ? JSON.parse(authlogin) : "";
  var initialUsername = storageDataAuthLogin ? storageDataAuthLogin.user_email :  "";

 // if(initialUsername==="vip@ciisummit.com" || initialUsername==="VIP@CIISUMMIT.COM" || initialUsername==="cleartrail@ciisummit.com"){

    return ( <Session_data /> )

 // }
}

export default Sessions;